import React from 'react';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/content';
function Stars({
  rating
}: {
  rating: number;
}) {
  return <div className="flex items-center gap-0.5" aria-label={`${rating} stelle su 5`} data-id="element-136" data-mp="2hcvx947g9a31">
      {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className={`h-3.5 w-3.5 ${star <= rating ? 'fill-gold-400 text-gold-400' : 'text-cream-300'}`} aria-hidden="true" data-id="element-137" data-mp="2ras4vm16hmwe" />)}
    </div>;
}
export function Reviews() {
  return <section className="px-6 py-12" data-id="element-138" data-mp="309nc91fyl31a">
      <div className="text-center" data-id="element-139" data-mp="352gftlzoy5bs">
        <p className="font-display text-[44px] font-semibold leading-none tracking-[-0.02em] text-ink-900" data-id="element-140" data-mp="353840bqyl0s1">
          4,8
        </p>
        <div className="mt-3 flex justify-center" data-id="element-141" data-mp="3a3dv9qtbgl9l">
          <Stars rating={5} data-id="element-142" data-mp="3f15pirhfojgy" />
        </div>
        <p className="mt-3 whitespace-nowrap text-[13.5px] text-ink-500" data-id="element-143" data-mp="3ey9pmxm0zkpv">
          Cosa dicono i genitori italiani
        </p>
      </div>

      <ul className="mt-8 space-y-3" data-id="element-144" data-mp="2rd6y85ptc0op">
        {reviews.map(review => <li key={review.name} className="rounded-2xl border border-cream-300 bg-white p-5" data-id="element-145" data-mp="2rab2mo1fto3f">
            <div className="flex items-center gap-3" data-id="element-146" data-mp="2mfx9yte5tv2g">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cream-200 font-display text-[15px] font-semibold text-ink-800" aria-hidden="true" data-id="element-147" data-mp="2hf9arkfs27x5">
                {review.name.charAt(0)}
              </span>
              <p className="flex-1 font-display text-[16px] font-semibold leading-tight text-ink-900" data-id="element-148" data-mp="3553m1xkg7ofa">
                {review.name}
                <span className="ml-1.5 font-sans text-[13px] font-normal text-ink-500" data-id="element-149" data-mp="30biyz0ke8euv">
                  {review.country}
                </span>
              </p>
              <Stars rating={review.rating} data-id="element-150" data-mp="3suoinj9iyk71" />
            </div>
            <p className="mt-3.5 text-[15.5px] leading-[1.65] text-ink-800" data-id="element-151" data-mp="3o2y574fajgbe">{review.text}</p>
          </li>)}
      </ul>
    </section>;
}